export function calculateCAGR({
  returnMultiple,
  years,
}: {
  returnMultiple: number;
  years: number;
}): number {
  return Math.pow(returnMultiple, 1 / years) - 1;
}
